export const schedule = {
  go: {
    start: "Starten",
    cantNow: "Jetzt nicht möglich",
    details: "Details",
  },
notFound: "Planung nicht gefunden",
loadError: {
title: "Dieser Zeitplan konnte nicht geladen werden",
description: "Überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
},
startFailed: "Diese Inspektion konnte nicht gestartet werden.",
starting: "Wird gestartet...",
loadingAsset: "Anlage wird geladen…",
breadcrumb: {
backToRequest: "← Zurück zur Anfrage",
scheduledInspection: "Geplante Inspektion",
},
calendarInvite: {
titleWithAsset: "Inspektion: {{asset}}",
titleFallbackAsset: "Anlage",
descriptionChecklist: "Checkliste: {{name}}",
addToCalendar: "Zum Kalender hinzufügen",
notNow: "Später",
confirmedTitle: "Termin bestätigt",
confirmedBody: "Das Team wurde benachrichtigt. Den Besuch in Ihren Kalender eintragen?",
},
sourceRequest: {
title: "Aus Anfrage",
fallback: "Diese geplante Inspektion bleibt mit dem Verlauf der ursprünglichen Anfrage verknüpft.",
openRequest: "Anfrage öffnen",
},
visit: {
label: "Besuch",
confirmed: "Durch Kontakt bestätigt",
awaitingConfirmation: "Warten auf Kontaktbestätigung",
},
readOnlyAssetNotice: "Diese Anlage wird schreibgeschützt für Sie freigegeben, daher kann keine Inspektion dafür gestartet werden. Bitten Sie den Besitzer um Bearbeitungszugriff oder führen Sie diese Inspektion von einer Anlage in Ihrem eigenen Arbeitsbereich aus aus.",
reschedule: {
accessibilityLabel: "Inspektion neu planen",
label: "Neu planen",
},
changeRequest: {
sent: "Anfrage gesendet",
savedOffline: "Auf diesem Gerät gespeichert — wird gesendet, sobald Sie wieder online sind",
sendFailed: "Die Anfrage konnte nicht gesendet werden",
decideFailed: "Die Entscheidung konnte nicht gespeichert werden",
photosNeedSignal: "Fotos benötigen Empfang zum Hochladen. Entfernen Sie sie, um diese Anfrage offline zu speichern, oder versuchen Sie es erneut, sobald Sie wieder online sind.",
},
overflow: {
moreActionsLabel: "Weitere Aktionen zur Planung",
sheetTitle: "Zeitplanoptionen",
},
status: {
  skipped: "Ausgelassen",
upcoming: "Bevorstehend",
due: "Jetzt fällig",
overdue: "Überfällig",
completed: "Abgeschlossen",
cancelled: "Abgebrochen",
},
alerts: {
errorTitle: "Fehler",
templateMissing: "Checkliste nicht gefunden.",
cancelTitle: "Planung stornieren",
cancelMessage: "Möchten Sie diese geplante Inspektion wirklich stornieren?",
cancelConfirm: "Planung stornieren",
no: "Nein",
deleteTitle: "Planung löschen",
deleteMessage: "Die Planung wird dauerhaft entfernt.",
deleteConfirm: "Löschen",
},
labels: {
asset: "Anlage",
checklist: "Checkliste",
assignedTo: "Zugewiesen an",
unassigned: "Nicht zugewiesen",
recurrence: "Wiederholung",
reminders: "Erinnerungen",
none: "Keine",
seriesEndDate: "Serienende (Datum)",
seriesEndTime: "Serienende (Uhrzeit)",
maxCompletedRuns: "Endet nach",
},
seriesEnd: {
sectionTitle: "Optionale Seriengrenzen",
helper: "Leer lassen für kein Limit. Die Serie endet, wenn ein Limit erreicht ist.",
maxPlaceholder: "z. B. 12",
errors: {
maxPositive: "Geben Sie eine ganze Zahl ≥ 1 ein oder lassen Sie das Feld leer.",
invalidEnd: "Datum und Uhrzeit des Serienendes sind ungültig.",
endBeforeStart: "Serienende muss am oder nach dem geplanten Start liegen.",
},
},
detail: {
  stopRepeat: {
    failed: "Die Wiederholung konnte nicht beendet werden. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
    done: "Diese Inspektion wiederholt sich nicht mehr.",
    confirm: "Wiederholung beenden",
    message: "Dieser Termin bleibt. Danach werden keine weiteren Termine erstellt.",
    title: "Diese Inspektion nicht mehr wiederholen?",
    action: "Wiederholung beenden",
  },
seriesEnds: "Wiederholung endet",
maxRuns_one: "Endet nach {{count}} Termin",
maxRuns_other: "Endet nach {{count}} Terminen",
unlimitedRuns: "Kein Limit",
noEndDate: "Kein Enddatum",
},
list: {
untilDate: "Bis {{date}}",
maxRunsChip_one: "Bis zu {{count}} Termin",
maxRunsChip_other: "Bis zu {{count}} Termine",
typeInspection: "Inspektion",
typeJob: "Auftrag",
filterActive: "Aktiv",
filterPast: "Vergangen",
filterAll: "Alle",
overdueChip: "Überfällig",
scheduleWork: "Arbeit planen",
scheduleSheetTitle: "Was möchten Sie planen?",
emptyTitle: "Nichts geplant",
emptyActiveSubtitle: "Planen Sie eine Inspektion oder einen Auftrag – beides erscheint hier.",
emptyPastSubtitle: "Keine vergangenen geplanten Arbeiten.",
emptyAllSubtitle: "Noch keine geplanten Arbeiten.",
},
unknownAsset: "Unbekannte Anlage",
unknownChecklist: "Unbekannte Checkliste",
templateMeta_one: "{{count}} Eintrag · {{category}}",
templateMeta_other: "{{count}} Einträge · {{category}}",
recurrence: {
none: "Einmalig",
hourly: "Jede Stunde",
daily: "Jeden Tag",
weekly: "Jede Woche",
biweekly: "Alle 2 Wochen",
monthly: "Jeden Monat",
quarterly: "Alle 3 Monate",
yearly: "Jedes Jahr",
},
reminder: {
at_time: "Zur geplanten Zeit",
"15min": "15 Minuten vorher",
"30min": "30 Minuten vorher",
"1hr": "1 Stunde vorher",
"2hr": "2 Stunden vorher",
"1day": "1 Tag vorher",
"2day": "2 Tage vorher",
},
actions: {
startNow: "Inspektion jetzt starten",
startFor: "Für {{name}} starten",
cancelSchedule: "Planung stornieren",
viewInspection: "Inspektion anzeigen",
delete: "Löschen",
},
planner: {
subtitle: "Datum wählen, Person zuweisen und festlegen.",
scheduleCta: "Planen",
scheduleInspection: "Inspektion planen",
scheduleJob: "Auftrag planen",
},
create: {
createChecklistCta: "Checkliste erstellen",
noChecklistsHint: "Noch keine Checklisten. Erstellen Sie eine, um weiter zu planen.",
overlayReturnFootnote: "Wird als Overlay geöffnet. Nach dem Speichern kehren Sie mit ausgewählter Checkliste zurück.",
ctaAccessibility: "Checkliste erstellen und zur Planung zurückkehren",
},
};
